module.exports = __webpack_public_path__ + "static/media/beetzmax-4.c037d96b.jpg";